import React from "react";
import Skeleton from "react-loading-skeleton";

const SkeletonLoader = ({ count = 1 }) => {
  return (
    <>
      <div className="rows">
        {[...Array(count)].map((_, index) => (
          <div key={index} className="cards p-0">
            <>
              <div style={{ position: "relative" }}>
                {/* Adjust Skeleton props as needed */}
                <Skeleton height={300} />
              </div>
              <div className="px-3 py-2">
                <h5 className="mb-0">
                  {/* Adjust Skeleton props as needed */}
                  <Skeleton width={200} count={2} />
                </h5>
              </div>
            </>
          </div>
        ))}
      </div>
    </>
  );
};

export default SkeletonLoader;
